module.exports = __webpack_public_path__ + "static/media/unpaid.b0fcde8d.svg";